import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { environment } from 'src/environments/environment';
import { IProfilePictureInputDTO } from '../dto/profilePictureInputDTO';
import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { TracingType } from 'src/app/services/monitoring/opentelemetry/tracer';
import { HttpAdapter } from 'src/app/infra/http/adapter';
import { IUserRemoteRepository, IUserRepositoryLoginParams, UserLoginOutputResponse, UserRefreshTokenInputDTO } from 'src/app/core/user/repository/user-remote-repository';
import { UserLoginOutput } from 'src/app/core/user/use-case/user-login-use-case.service';
import { SessionStore } from 'src/app/store/session.service';
import { UserGetByIdOutput } from 'src/app/core/user/use-case/user-get-by-id.service';
import { Result } from 'neverthrow';
import { UserPhotoUploadInput } from 'src/app/core/user/use-case/user-photo-upload.service';
import { HttpResult } from 'src/app/infra/http/type';
@Injectable({
  providedIn: 'root'
})
export class UserRemoteRepositoryService implements IUserRemoteRepository{

  private baseUrl = `${environment.apiURLStage.slice(0, -1)}`; // Your base URL

  constructor(
    private httpService: HttpService,
    private http: HttpAdapter,
  ) { }

  async uploadPhoto(input: UserPhotoUploadInput): Promise<Result<HttpResult<any>, HttpErrorResponse>> {
    return await this.http.post<UserGetByIdOutput>(`${this.baseUrl}/Users/${SessionStore.user.UserId}/photo`, input)
  }

  // @APIReturn(MessageOutPutDTOSchema, 'get/Messages')
  async login(input: IUserRepositoryLoginParams) {
    return await this.http.post<UserLoginOutputResponse>(`${this.baseUrl}/Users/login`, input)
  }

  // @APIReturn(MessageOutPutDTOSchema, 'get/Messages')
  async logout() {

    return await this.http.post<UserLoginOutput>(`${this.baseUrl}/Users/${SessionStore.user.UserId}/logout`, {})
  }

  async refreshToken(input: UserRefreshTokenInputDTO) {

    return await this.http.post<UserLoginOutput>(`${this.baseUrl}/Users/RefreshToken`, input)
  }

  async getUserProfilePhoto(guid: string, tracing?: TracingType) {
    return await this.http.get<UserGetByIdOutput>(`${this.baseUrl}/Users/${SessionStore.user.UserId}`, {})
  }

}
